import { post } from '../utilities/api';

export const postReservationProposal = data => post({
  url: '/reservation/proposal',
  data
});

export const postReservationConfirmation = data => post({
  url: '/reservation/confirm',
  data
});
